module.exports = __webpack_public_path__ + "static/img/logo_lyx.0508e22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_lyx.png
// module id = Wjuh
// module chunks = 1